import React from "react";

export default function Alert({ variant = "info", role = "status", children }) {
  return (
    <div className={`alert alert--${variant}`} role={role}>
      {children}
    </div>
  );
}
